// import {getEnv} from '../../shared/Services/env'
// const OA_KEY = getEnv('OA_KEY')
let DefaultHeaders  
// const ipc = window.require('electron').ipcRenderer

// ipc.on('receive-key', (event, arg)=>{
//   // console.log('in OA_KEY got', arg)

//   if(arg[0]!=='OA_KEY') return
//   // console.log('got OA_KEY', arg)

//   DefaultHeaders = {
//     Authorization: `OATU 1:${arg[1]}`,
//     'if-modified-since': ''
//   }
//   // console.log('OA INIT', DefaultHeaders)
//   ipc.send('key-ready', 'OA_KEY')
// })
// ipc.send('request-key', 'OA_KEY')

export const toArray = async function(type, limit=0){

  let url = `https://laneconsultinggroup.openasset.com/REST/1/${type}?limit=${limit}`
  console.log('attempting at url', url)
    let arr = await fetch(url,
    {
      method:'GET',
      headers:DefaultHeaders
    }).catch(err => console.log('TEST OA API ERR', type, err))
    arr = await arr.json()
    // console.log('got res from checking all', type, arr )
    return arr

}

export const toArrayWithExpansion = async function(type, limit=0, ...expansions){
    expansions = expansions.map(itm=>(`&${itm}=all`)).join('')
    let url = `https://laneconsultinggroup.openasset.com/REST/1/${type}?limit=${limit}${expansions}`
    console.log('attempting at url', url)
    let arr = await fetch(url,
    {
      method:'GET',
      headers:DefaultHeaders
    }).catch(err => console.log('TEST OA API ERR', type, err))
    arr = await arr.json()
    // console.log('got res from checking all', type, arr )
    return arr

}

export const get = async function(type, id){
  if (Array.isArray(id)){
    id = id.join(',')
  }
  let res = await fetch(`https://laneconsultinggroup.openasset.com/REST/1/${type}?id=${id}`,
  {
    method:'GET',
    headers:DefaultHeaders
  }).catch(err => console.log('TEST OA API ERR', type, err))
  res = await res.json()
  console.log('got res from get', type, res )
  return res

}

export const getBy = async function(type, id, prop, ...expansions){
    expansions = expansions.map(itm=>(`&${itm}=all`)).join('')
    if (Array.isArray(id)){
    id = id.join(',')
  }
  let res = await fetch(`https://laneconsultinggroup.openasset.com/REST/1/${type}?limit=0&${prop}=${id}${expansions}`,
  {
    method:'GET',
    headers:DefaultHeaders
  }).catch(err => console.log('TEST OA API ERR', type, err))
  res = await res.json()
  console.log('got res from get', type, res )
  return res

}

export const getWithExpansion = async function(type, id, ...expansions){
    expansions = expansions.map(itm=>(`&${itm}=all`)).join()
    if (Array.isArray(id)){
      id = id.join(',')
    }

    let res = await fetch(`https://laneconsultinggroup.openasset.com/REST/1/${type}?id=${id}${expansions}`,
    {
      method:'GET',
      headers:DefaultHeaders
    }).catch(err => console.log('TEST OA API ERR', type, err))
    res = await res.json()
    console.log('got res from get', type, res )
    return res

}

export const getSizes = async function(type, id){

    let res = await fetch(`https://laneconsultinggroup.openasset.com/REST/1/${type}?id=${id}&sizes=all`,
    {
      method:'GET',
      headers:DefaultHeaders
    }).catch(err => console.log('TEST OA API ERR', type, err))
    res = await res.json()
    console.log('got res from get', type, res )
    return res

}


export const uploadPhoto = async function(data, file){
  const strikeUrl = `https://laneconsultinggroup.openasset.com/REST/1/Files/`
  let body = new FormData()
  // let imageBlob = await getFileAsBlob(file)
  console.log('got image for upload', file)
  body.append('file', file, data.original_filename)
  body.append('_jsonBody', JSON.stringify(data))
  console.log('strikeurl?', strikeUrl, body, data)
  for (const pair of body.entries()) {
    console.log(`${pair[0]}`, pair[1]);
  }
  return await fetch(strikeUrl,
  {
    method:'POST',
    headers:{
      Authorization: `OATU 1:by1Bbi3rDoyk2DWYH0nZw4pjJSX5co6/ZyisAda5Ino`
    },
    body
  }).catch(err => console.log('TEST UPLOAD OA API ERR', 'Files', err))
}

export const getPhotoFromURL = async function(url){
  let imgres = await fetch(url, {
      method:'GET',
      headers:DefaultHeaders
    }
  ).catch(err => console.log('failed getting image i think', err))

  return await imgres.blob()
}
